import * as lib from '~/dependencies';
import { colors, fonts } from '~/layout';

export const Container = lib.styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  padding: 15px;
  height: 375px;
  gap: 10px;
  color: ${colors.red11};
  text-align: center;
  overflow-y: scroll;

  span {
    font-size: ${fonts.default}px;
  }
`;

export const Card = lib.styled.div`
  background-color: #fbefab;
  padding: 20px;
  font-size: ${fonts.default}px;
  border-radius: 5px;
  color: #3d505a;
`;

export const Bold = lib.styled.b``;

export const List = lib.styled.ul`
  list-style: none;
  margin-top: 20px;
  text-align: left;
  padding-left: 5px;
`;

export const Line = lib.styled.li`
  margin-bottom: 7px;
`;
